// extracted by mini-css-extract-plugin
export default {"icon":"Unsubscribe_icon__ZUnYe","title":"Unsubscribe_title__3bmEH","text":"Unsubscribe_text__cvTCi","button":"Unsubscribe_button__6XnA+"};